import axios from "axios";

export const defaultDistanceSettings = {
  minDistance: 10,
  maxDistance: 500,
  defaultDistance: 50,
  distanceUnit: "KM",
};

const toNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const normalizeDistanceSettings = (data = {}) => {
  let minDistance = toNumber(data.min_distance, defaultDistanceSettings.minDistance);
  let maxDistance = toNumber(data.max_distance, defaultDistanceSettings.maxDistance);
  let defaultDistance = toNumber(data.default_distance, defaultDistanceSettings.defaultDistance);
  const distanceUnit = String(data.distance_unit || defaultDistanceSettings.distanceUnit).toUpperCase() === "MILES"
    ? "MILES"
    : "KM";

  if (minDistance > maxDistance) {
    [minDistance, maxDistance] = [maxDistance, minDistance];
  }

  defaultDistance = Math.min(Math.max(defaultDistance, minDistance), maxDistance);

  return { minDistance, maxDistance, defaultDistance, distanceUnit };
};

export const fetchDistanceSettings = async (basUrl) => {
  try {
    const res = await axios.get(`${basUrl}distance_settings`);
    if (res.data?.Result === "true") {
      return normalizeDistanceSettings(res.data);
    }
  } catch (err) {
    return defaultDistanceSettings;
  }
  return defaultDistanceSettings;
};
